var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCorrectProduct && _vm.remainingTime.length)?_c('div',{staticClass:"discount-timer"},[_c('ClockIcon',{attrs:{"type":"white"}}),_vm._v(" "),_c('span',{staticClass:"discount-timer__text"},[_vm._v(_vm._s(_vm.remainingTime))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }